import { combineReducers } from "redux";

import app from "./app";
import collections from "./collections";
import hovered from "./hovered";
import organization from "./organization";
import sections from "./sections";
import selected from "./selected";
import settings from "./settings";
import target from "./target";
import theme from "./theme";
import versions from "./versions";

export default combineReducers({
  app,
  collections,
  hovered,
  organization,
  sections,
  selected,
  settings,
  target,
  theme,
  versions
});
